import { render } from "./EnIconCustomer.vue?vue&type=template&id=803c918e"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/icons/navigation/EnIconCustomer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "803c918e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('803c918e', __exports__)) {
    api.reload('803c918e', __exports__)
  }
  
  module.hot.accept("./EnIconCustomer.vue?vue&type=template&id=803c918e", () => {
    api.rerender('803c918e', render)
  })

}


export default __exports__